import gsap, { SplitText } from "@lib/gsap";
import { onMount, onView, onTrack, onDestroy, onPageIn, onPageOut } from "./_";

export default function (element, dataset) {
  const button = element.querySelector(".dropdown_toggle_clickable");
  const content = element.querySelector(".dropdown_content");
  const variant = element.getAttribute("data-wf--dropdown--variant");
  function openDropdown() {
    button.setAttribute("aria-expanded", "true");
    element.classList.add("is-active");
    let tl = gsap.timeline({
      onComplete: () => {
        if (typeof ScrollTrigger !== "undefined") ScrollTrigger.refresh();
      },
    });
    tl.set(content, { display: "block" });
    tl.fromTo(
      content,
      { height: 0 },
      { height: "auto", ease: "power1.inOut", duration: 0.4 },
    );
  }
  function closeDropdown() {
    button.setAttribute("aria-expanded", "false");
    element.classList.remove("is-active");
    let tl = gsap.timeline({
      onComplete: () => {
        if (typeof ScrollTrigger !== "undefined") ScrollTrigger.refresh();
      },
    });
    tl.to(content, { height: 0, ease: "power1.inOut", duration: 0.4 });
    tl.set(content, { display: "none" });
  }
  function isOpen() {
    return button.getAttribute("aria-expanded") === "true";
  }
  button.addEventListener("click", () => {
    isOpen() ? closeDropdown() : openDropdown();
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && isOpen()) {
      closeDropdown();
      button.focus();
    }
    if (
      (e.key === "ArrowDown" || e.key === "ArrowUp") &&
      isOpen() &&
      element.contains(document.activeElement)
    ) {
      e.preventDefault();
      const items = [...content.querySelectorAll("a, button")];
      if (items.length === 0) return;
      const currentIndex = items.indexOf(document.activeElement);
      let nextIndex;
      if (currentIndex === -1) {
        nextIndex = e.key === "ArrowDown" ? 0 : items.length - 1;
      } else {
        nextIndex =
          (currentIndex + (e.key === "ArrowDown" ? 1 : -1) + items.length) %
          items.length;
      }
      items[nextIndex].focus();
    }
  });
  document.addEventListener("click", (e) => {
    if (isOpen() && !element.contains(e.target)) closeDropdown();
  });

  if (element.getAttribute("data-open-on-hover-in") === "True") {
    element.addEventListener("mouseenter", () => {
      if (!isOpen()) openDropdown();
    });
  }

  if (element.getAttribute("data-close-on-hover-out") === "True") {
    element.addEventListener("mouseleave", () => {
      if (isOpen()) closeDropdown();
    });
  }
}
